import { Accordion, AccordionTab } from 'primereact/accordion';

function NotesPage() {
	return (
	<div className="notes_content">
		<Accordion multiple activeIndex={[]}>
			<AccordionTab header="Intersection theory, Shioda-Tate formula and the zeta function of arithmetic surfaces">
				<p className="m-0">We introduce intersection theory on arithmetic surfaces and use it to prove a Shioda-Tate formula and reformulate the Birch and Swinnerton-Dyer conjecture for elliptic curves in terms of elliptic surfaces.
				&nbsp;<span>(<a href={require('../content/arithmetic_shioda-tate.pdf')} target='_blank' rel="noreferrer">PDF</a>, 17 pp)</span>
				</p>
			</AccordionTab>
			<AccordionTab header="Algebraicity of the division points of the trifolium and related topics">
				<p className="m-0">We prove that the points dividing the lemniscate "with three leaves" in parts of equal length are algebraic, generalising results of Gauss and Abel. We also study further related questions on algebraicity of division points and transcendence of length of a class of curves containing polynomial lemniscates.
				&nbsp;<span>(<a href={require('../content/division_lemniscates.pdf')} target='_blank' rel="noreferrer">PDF</a>, 20 pp)</span>
				</p>
			</AccordionTab>		
			<AccordionTab header="The isogeny theorem for rational elliptic curves via functional transcendence">
				<p className="m-0">We explain a proof, due to the Chudnovsky brothers, of the fact that two rational elliptic curves with the same number of points modulo every prime are isogenous.
				&nbsp;<span>(<a href={require('../content/Chudnovsky.pdf')} target='_blank' rel="noreferrer">PDF</a>, 9 pp)</span>
				</p>
			</AccordionTab>			
		</Accordion>
	</div>
	);
}

export default NotesPage;